module.exports = __webpack_public_path__ + "img/bg-accident-item-5.6c4a5d58.png";